import { ChatWithPdfTableType } from "@/app/ai-tools/chat-with-pdf/root";
import logo from "@/assets/images/brand-mini-logo.svg";
import Image from "next/image";

const iconSize = `flex-shrink-0 inline-block w-[30px] h-[30px] pr-1`;

const tableHeaderStyle = ` py-2 px-3 text-[16px] leading-6 font-semibold xl:leading-7 text-[#202020] `;

const logoHolderStyle = `w-[70px] h-[70px] flex items-center justify-center flex-col`;

const tableDataStyle = `py-2 px-3 text-[14px] font-normal text-[#202020] `;

const ChatWithPdfTable = ({
  productInfo,
}: {
  productInfo: ChatWithPdfTableType;
}) => {
  return (
    <section className="pb-[30px] xlg:pb-16">
      <div className="container xl:px-20">
        {/* table wrapper */}
        <div className="compare_product_table_wrapper w-full overflow-y-auto rounded-md border border-[#CECECE]">
          <table className="w-full">
            <thead>
              <tr>
                <th
                  className={tableHeaderStyle + "w-[70%] text-left xl:w-[60%]"}
                >
                  Compare features with {productInfo.products[0].productName}
                </th>
                <th className={tableHeaderStyle + "text-center"}>
                  <div className="flex justify-center">
                    <div className={logoHolderStyle}>
                      <Image
                        src={logo}
                        alt="Kroolo Chat with PDF brand"
                        width={36}
                        height={36}
                      />
                      <div className="text-center text-[14px] font-semibold text-[#202020]">
                        {productInfo.products[0].productTitle}
                      </div>
                    </div>
                  </div>
                </th>
                <th className={tableHeaderStyle + "text-center"}>
                  <div className="flex justify-center">
                    <div className={logoHolderStyle}>
                      <Image
                        src={productInfo.products[0].productLogo || logo}
                        alt="Kroolo Chat PDF product"
                        width={36}
                        height={36}
                      />
                      <div className="text-center text-[14px] font-semibold text-[#202020]">
                        {productInfo.products[0].productTitle1 ||
                          productInfo.products[0].productName}
                      </div>
                    </div>
                  </div>
                </th>
                {productInfo.products && (
                  <th className={tableHeaderStyle + "text-center"}>
                    <div className="flex justify-center">
                      <div className={logoHolderStyle}>
                        <Image
                          src={productInfo.products[0].productLogo2 || logo}
                          alt="PDF AI comparison product"
                          width={36}
                          height={36}
                        />
                        <div className="text-center text-[14px] font-semibold text-[#202020]">
                          {productInfo.products[0].productTitle2 ||
                            productInfo.products[0].productName}
                        </div>
                      </div>
                    </div>
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {productInfo.compareTable.map((item, index) => (
                <tr key={index} className="border-t border-[#CECECE]">
                  <td className={tableDataStyle}>
                    <p className="min-w-[130px]">{item.feature}</p>{" "}
                  </td>
                  {item.value.map((value, i) => (
                    <td className={tableDataStyle + "text-center"} key={i}>
                      {value ? (
                        <div className="flex justify-center">
                          <div className={iconSize}>
                            <svg
                              width="28"
                              height="28"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M35.0662 17.8437C35.0662 27.4839 27.2514 35.2987 17.6112 35.2987C7.97112 35.2987 0.15625 27.4839 0.15625 17.8437C0.15625 8.20354 7.97112 0.388672 17.6112 0.388672C27.2514 0.388672 35.0662 8.20354 35.0662 17.8437ZM25.3139 14.637L26.4712 13.4799L24.1569 11.1657L22.9998 12.3228L14.3384 20.9841L12.2227 18.8684L11.0656 17.7113L8.7514 20.0255L9.90851 21.1827L13.1813 24.4554C13.8204 25.0945 14.8565 25.0945 15.4956 24.4554L25.3139 14.637Z"
                                fill="#12B76A"
                              />
                            </svg>
                          </div>
                        </div>
                      ) : (
                        <div className="flex justify-center">
                          <div className={iconSize}>
                            <svg
                              width="28"
                              height="28"
                              viewBox="0 0 35 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.5068 32.6786C25.507 32.6786 32.0526 26.133 32.0526 18.1327C32.0526 10.1325 25.507 3.58691 17.5068 3.58691C9.50656 3.58691 2.96094 10.1325 2.96094 18.1327C2.96094 26.133 9.50656 32.6786 17.5068 32.6786Z"
                                stroke="#FF3466"
                                stroke-width="2.18187"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M13.3984 22.2495L21.6314 14.0166"
                                stroke="#FF3466"
                                stroke-width="2.18187"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M21.6314 22.2495L13.3984 14.0166"
                                stroke="#FF3466"
                                stroke-width="2.18187"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      )}{" "}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ChatWithPdfTable;
